<template>
  <div class="hiddenManage">
    <tree-box title="隐患配置" @sendID="getID" showTree>
      <template slot="message">
        <h3>免责申明</h3>
        <p style="color: red;margin-top: 20px;">隐患和告警请根据单位实际情况谨慎配置，关闭得隐患和告警将不会上报至平台，如有因自行配置导致的隐患和告警没有上报，出现的安全事故问题请自行承担后果！</p>
        <div class="main-con">
          <div class="left-con">
            <p>隐患</p>
            <el-checkbox-group v-model="checkList">
              <div class="check-item" v-for="item in tableList">
                <el-checkbox :label="item.alertLevel" :key="item.alertLevel">{{item.alertLevelName}}</el-checkbox>

              </div>


            </el-checkbox-group>
          </div>
          <div class="right-con">
            <p>告警</p>
            <el-checkbox-group v-model="checkList2">
              <div class="check-item" v-for="item in tableList2">
                <el-checkbox :label="item.faultCode" :key="item.faultCode">{{item.faultName}}</el-checkbox>

              </div>


            </el-checkbox-group>
          </div>
        </div>
        <div class="confirm">
          <el-button type="primary" @click="confirmEdit" style="float: right;margin-right: 20px;">修改</el-button>
        </div>
      </template>
    </tree-box>



  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import treeBox from "./components/treeBox";
export default {
  name: "hiddenManger",
  components: { treeBox },
  data() {
    return {
      riskLevel: [],
      id: null,
      level: null,
      deptId: 15,
      tableList: [],
      loading: false,
      dialog: false,
      checkList: [],
      checkList2: [],
      tableList2: [],
    };
  },
  methods: {
    getID(id) {
      this.deptId = id;
      this.queryTableList();
    },
    confirmEdit() {
      this.$confirm("请再次确认您的修改操作，并保证取消推送的隐患和告警确实不会导致安全问题，一旦勾选取消推送，对应隐患及报警无法向您进行相应的提醒和推送，后续因此导致的安全问题请自行负责！", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        Axios.ajax({
          url: "/warnPush/saveConfig",
          method: "post",
          data: {
            deptId: this.deptId,
            alertLevelList: this.checkList,
            eventFaultCodeList: this.checkList2,
          },
        }).then((res) => {
          if (res.resultCode == 0) {
            this.$message.success("修改成功！");
          } else {
            this.$message.warning("修改失败！");
          }
          this.queryTableList();
        });
      })
    },
    queryTableList() {
      this.loading = true;
      const params = {
        url: "/warnPush/getAlertLevels",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      };
      Axios.ajax(params).then(({ data }) => {
        this.loading = false;
        this.tableList = data;
        this.checkList=[]
        for(let i=0;i<this.tableList.length;i++){
          if(this.tableList[i].checked){
            this.checkList.push(this.tableList[i].alertLevel)

          }
        }

      });
      const params2 = {
        url: "/warnPush/getEventFaults",
        method: "post",
        data: {
          deptId: this.deptId,
        },
      };
      Axios.ajax(params2).then(({ data }) => {

        this.tableList2 = data;
        this.checkList2=[]
        console.log(data)
        for(let i=0;i<this.tableList2.length;i++){
          if(this.tableList2[i].checked){
            this.checkList2.push(this.tableList2[i].faultCode)

          }
        }

      });
    },

    queryRiskLevels() {
      Axios.ajax({
        url: "/riskManage/allRiskLevels",
        method: "get",
      }).then(({ data }) => {
        this.riskLevel = data.map((item) => {
          return {
            label: item.levelName,
            value: item.sysRiskLevel,
          };
        });
      });
    },
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
.hiddenManage {
  .message {
    h3 {
      padding: 0 10px;
      border-left: 2px solid #2a62ff;
    }
    .table {
      height: 90%;
      overflow: auto;
      padding-top: 32px;
      .tableBtn {
        cursor: pointer;
        color: #2a62ff;
      }
    }
    .tip {
      width: 100%;
      text-align: center;
      padding: 20%;
      color: #7d879f;
      font-size: 16px;
    }
    .btn-group {
      margin-top: 44px;
    }
    .btn-group button:first-child {
      margin-right: 40px !important;
    }
  }
  .dialog {
    font-size: 14px;
    text-align: center;
    label {
      margin-right: 12px;
    }
  }
}
.main-con{
  height: 470px;
  margin-top:60px;
  .left-con{
    display: inline-block;
    vertical-align: top;
    height: 300px;
    width: 400px;
    border-right: 2px solid #ddd;
    padding-left: 40px;
  }
  .right-con{
    display: inline-block;
    vertical-align: top;
    padding-left: 80px;
  }
  .check-item{
    margin-top: 10px;
  }
}
</style>
